'use client'

import Link from 'next/link'
import { useState } from 'react'
import MotionFadeIn from '@/components/ui/MotionFadeIn'
import ArrowButton from '@/components/ui/ArrowButton'
import ThemeIcon from '@/components/ui/ThemeIcon'

export interface JobItem {
  id: string
  title: string
  location: string
  workload: string
  slug: string
}

interface JobsOverviewClientProps {
  jobs: JobItem[]
}

export default function JobsOverviewClient({ jobs }: JobsOverviewClientProps) {
  const [hoveredJobId, setHoveredJobId] = useState<string | null>(null)

  return (
    <div className="space-y-6">
      {jobs.map((job) => {
        const href = `/karriere/jobs/${job.slug}`
        return (
          <MotionFadeIn key={job.id} initialY={12}>
            <article className="grid items-center gap-x-4 gap-y-1 grid-cols-[auto_1fr_auto] md:gap-10 md:grid-cols-[auto_1fr_auto_auto] max-w-5xl mx-auto">
              <ThemeIcon
                size="size-10"
                alt="Lüchinger Icon"
                ariaHidden={false}
              />
              <h3 className="title-xl text-primary">
                <Link
                  href={href}
                  onMouseEnter={() => setHoveredJobId(job.id)}
                  onMouseLeave={() => setHoveredJobId(null)}
                  onFocus={() => setHoveredJobId(job.id)}
                  onBlur={() => setHoveredJobId(null)}
                  className="outline-none focus-visible:underline cursor-pointer"
                >
                  {job.title}
                </Link>
              </h3>
              <div className="hidden md:flex flex-col">
                <span className="body-base text-primary !font-bold">{job.location}</span>
                <span className="body-base text-secondary">{job.workload}</span>
              </div>
              <div className="justify-self-end row-span-2 self-center md:row-span-1">
                <ArrowButton
                  href={href}
                  size="md"
                  color="brand"
                  groupHover={hoveredJobId === job.id}
                />
              </div>
              <div className="md:hidden col-start-2">
                <span className="body-base text-primary !font-bold">{job.location}</span>
                <span className="ml-2 body-base text-secondary">{job.workload}</span>
              </div>
            </article>
          </MotionFadeIn>
        )
      })}
    </div>
  )
}
